export default "__VITE_ASSET__DDod2bX___"